
const instantAssistance = [{
  desc: '查询商户设备列表',
  options: {
    url: '/partnerDevice/queryPartnerDeviceList',
    method: 'get',
    baseURL: '/insapi/v3/equity/device'
  }
}, {
  desc: '查询商户设备配置信息',
  options: {
    url: '/partnerDevice/queryPartnerDeviceInfo',
    method: 'get',
    baseURL: '/insapi/v3/equity/device'
  }
}, {
  desc: '手机号查询保单信息接口(新)',
  options: {
    url: '/accept/queryUserPolicy',
    method: 'post',
    baseURL: '/insapi/v3/insured/accept'
  }
}, {
  desc: '保存商户设备配置信息',
  options: {
    url: '/partnerDevice/savePartnerDeviceInfo',
    method: 'post',
    baseURL: '/insapi/v3/equity/device'
  }
}, {
  desc: '查询商户设备订单列表',
  options: {
    url: '/partnerDevice/queryPartnerOrderList',
    method: 'get',
    baseURL: '/insapi/v3/equity/device',
    showLoading: false // 是否显示loading框
  }
}, {
  desc: '救援信息查询',
  options: {
    url: '/rescue/queryPartnerOrderRescueInfo',
    method: 'get',
    baseURL: '/insapi/v3/equity/device'
  }
}, {
  desc: '救援信息查询',
  options: {
    url: '/sms/querySmsRecordList',
    method: 'get'
  }
}, {
  desc: '发送救援短信',
  options: {
    url: '/callOrder/sendRescueSms',
    method: 'post',
    baseURL: '/insapi/v3/equity/device'
  }
}, {
  desc: '设备服务人员分配',
  options: {
    url: '/partnerDevice/deviceServiceAssign',
    method: 'post',
    baseURL: '/insapi/v3/equity/device'
  }
}]
export default instantAssistance



// WEBPACK FOOTER //
// ./src/api/instantAssistance.js